import { useState, useEffect, useContext } from 'react';
import chainHotelsRequest from '../../services/chainHotels.service';
import { useRouter } from 'next/router';
import { showError } from '../../shared/utils/utils';
import * as GtmUtils from '../../shared/utils/GtmUtils';
import { ThemeContext } from '../../shared/contexts/Theme.context';

function useHotelSelector() {
  const router = useRouter();
  const { state: themeState } = useContext(ThemeContext);
  const [state, setState] = useState({
    loading: true,
    hotelId: null,
  });

  useEffect(() => {
    GtmUtils.customPageView({
      stepName: 'hotelSelector',
      chainName: themeState.chainName,
    });
  }, []);

  const actions = {
    getHotels: () => {
      const chainId = router.query.chainId;
      if (chainId) {
        chainHotelsRequest(chainId)
          .then(chainHotels => {
            updateState({ loading: false, chainHotels });
          })
          .catch(error => {
            showError(error);
          });
      }
    },
    selectHotel: hotelId => {
      if (hotelId) {
        router.push(
          '/hotel/[hotelId]/bookingSearchForm',
          `/hotel/${
            state.chainHotels.hotels.find(hotel => hotel.id == hotelId).slug
          }/bookingSearchForm`
        );
      }
    },
    setHotel: hotelId => {
      updateState({ hotelId });
    },
  };

  useEffect(actions.getHotels, [router.query.chainId]);

  function updateState(newState) {
    setState(previousState => ({ ...previousState, ...newState }));
  }

  return { state, actions };
}

export default useHotelSelector;
